export const parseDaysOffset = (offset: string): number => {
  const parts = offset.split("T");
  const matched = parts[0].match(/(-)?P(\d+)D/);
  if (matched === null) {
    return 0;
  }
  return Number(parts[0].replace(/[PD]/g, ""));
};

export const daysToOffset = (days: number, time = ""): string => {
  return `${days < 0 ? "-" : ""}P${Math.abs(days)}D${time}`;
};
